import axios from "@/api/axios";

export default {
  // Get all brands
  getBrands(params = {}) {
    return axios.get("/brands", { params });
  },

  // Get single brand
  getBrand(id) {
    return axios.get(`/brands/${id}`);
  },

  // Create brand
  createBrand(data) {
    return axios.post("/brands", data);
  },

  // Update brand
  updateBrand(id, data) {
    return axios.put(`/brands/${id}`, data);
  },

  // Delete brand
  deleteBrand(id) {
    return axios.delete(`/brands/${id}`);
  },

  // Get categories by brand
  getCategories(brandId) {
    return axios.get(`/brands/${brandId}/categories`);
  },
};
